import React, { useState } from "react";
import { formatCurrency, formatFrequency } from "utils/HelperFunctions";
import { CurrentProduct, PlanFilter } from "types/subscriptionAndPlans";

interface CurrentPlanCardProps {
  item: CurrentProduct;
  selectedPlan: PlanFilter;
  isDismissed: boolean;
  onToggle: (cp: CurrentProduct) => void;
  index: string;
}

const CurrentPlanCard: React.FC<CurrentPlanCardProps> = ({
  item,
  selectedPlan,
  isDismissed,
  onToggle,
}) => {
  const [isImgErr, setIsImgErr] = useState<boolean>(false);
  return (
    <div
      className={`w-full lg:p-5 p-4 rounded-md border h-full ${
        isDismissed
          ? "border-strokePrimary cursor-not-allowed"
          : "border-blue cursor-pointer"
      } animate__animated animate__fadeIn`}
      onClick={() => {
        if (!isDismissed) onToggle(item);
      }}
      role="button"
    >
      <div className="w-full flex justify-between items-start sm:flex-row flex-col sm:gap-0 gap-2">
        <div className="flex flex-col justify-center">
          <div className="flex gap-2 items-center text-txtParagraph lg:text-[22px] text-lg leading-[28.64px] font-medium">
            {item?.image_name && item?.image_path && !isImgErr ? (
              <img
                src={`${item?.image_path}`}
                alt={item?.image_name}
                className="w-[26px] h-[26px] object-contain "
                onError={(e) => {
                  setIsImgErr(true);
                }}
              />
            ) : (
              <></>
            )}
            <span className="capitalize">
              {item?.name?.toLowerCase?.() || item?.name}
            </span>
            <span className="py-1 px-3 bg-iconBright text-sm text-white capitalize font-medium rounded-[30px]">
              Current plan
            </span>
          </div>
          <div className="lg:mt-2 mt-[6px]">
            <span className="lg:text-base text-sm font-bold text-txtPrimary">
              {formatCurrency(item?.amount)}
            </span>{" "}
            <span className="text-txtSecondary lg:text-base text-sm">
              {selectedPlan?.bottomDisplay}
            </span>
          </div>
          {item?.quantity ? (
            <div className="lg:mt-4 mt-3 lg:text-base text-sm text-txtSecondary">
              Quantity: {item?.quantity}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CurrentPlanCard;
